import ScrollArea2D from './scrollarea2d';
import LineDataset from '../_internal/datasets/line';
/**
 * Creates ScrollLine2D class
 */
class ScrollLine2D extends ScrollArea2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ScrollLine2D';
  }

  /**
   * Constructor fn of ScrollLine2D class
   */
  constructor () {
    super();
    this.canvasborderthickness = 1;
    this.avgScrollPointWidth = 75;
    this.defaultPlotShadow = 1;
    this.binSize = 0;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ScrollLine2D';
  }

  /**
   * Sets default chart configuration
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Scrollable Multi-series Line Chart';
    config.defaultDatasetType = 'line';
    config.zeroplanethickness = 1;
    config.zeroplanealpha = 40;
    config.showzeroplaneontop = 0;
    config.enablemousetracking = true;
    config.defaultcrosslinethickness = 1;
  }

  /** This method return the dataset definations for this charts **/
  getDSdef () {
    return LineDataset;
  }
  /** This method return the dataset-group definations for this charts **/
  getDSGroupdef () {
    return undefined;
  }
}
export default ScrollLine2D;
